/*
 * @Date: 2021-01-25 10:18:23
 * @LastEditors: guantingting
 * @LastEditTime: 2021-04-19 09:58:44
 */
import ajax from './request'
// const wx = require('weixin-js-sdk')
import wx from 'weixin-js-sdk'
const _domain = () => {
  if (/\.cekid\.com/i.test(document.domain)) {
    return 'cekid'
  } else {
    return 'haiziwang'
  }
}
class weChat{
  constructor(appName) {
    this.appName = appName || 'mall'
    this.signUrl = ''
  }
  /**
   * @description: 获取cms配置appid及签名地址
   * @param {*}
   * @return {*}
   */
  async getAppid() {
    try {
      let data = await ajax({method:"get", url: "https://cms.cekid.com/publish/998/sdkConfig.json"})
      const {appidObj = {}} = data.data || {}
      return appidObj[this.appName]
    } catch (error) {
      console.error(error)
      return {}
    }
  }
  /**
   * @description: 获取签名 默认用主小程序的appid及签名地址
   * @param {*}
   * @return {*}
   */
  async getSignature() {
    try {
      if (!this.signUrl) {
        let addObj = await this.getAppid()
        const {signUrl='hzw_club/js/signature'} = addObj || {}
        let url = `https://wxapi.${_domain()}.com/${signUrl}?url=${encodeURIComponent(location.href.split('#')[0])}&t=${Date.now()}`
        this.signUrl = url
      }
      let res = await ajax({method:"get", url: this.signUrl})
      const {appid, noncestr, signature, timestamp} = res || {}
      wx && wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: appid, // 必填，公众号的唯一标识
        timestamp: timestamp, // 必填，生成签名的时间戳
        nonceStr: noncestr, // 必填，生成签名的随机串
        signature: signature,// 必填，签名
        jsApiList: [
          'scanQRCode',
          'getLocation',
          'openLocation',
          'closeWindow',
          'hideMenuItems',
          'showMenuItems',
          'hideAllNonBaseMenuItem',
          'showAllNonBaseMenuItem',
          'openBusinessView',
          'updateAppMessageShareData',
          'updateTimelineShareData',
          'onMenuShareTimeline',
          'onMenuShareAppMessage',
          'onMenuShareQQ',
          'onMenuShareWeibo',
          'onMenuShareQZone',
          'openBusinessView',
          'wx-open-launch-weapp',
        ], // 必填，需要使用的JS接口列表
        openTagList: [
          'wx-open-launch-weapp',
        ]
      });
      return true
    } catch (error) {
      return false
    }
  }
  /**
   * @description: wx.ready
   * @param {*} fn
   * @return {*}
   */
  async ready(fn) {
    if (await this.getSignature()) {
      wx && wx.ready(() => {
        fn && fn()
      })
    } else {
      throw new Error('获取签名失败')
    }
  }
  /**
   * @description: 微信扫一扫
   * @param {*} needResult // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
   * @param {*} scanType // 可以指定扫二维码还是一维码，默认二者都有
   * @return {*}
   */
  scanQRCode({needResult = 0, scanType = ['qrCode', 'barCode']} = {}) {
    return new Promise((resolve,reject)=>{
      this.ready(() => {
        wx && wx.scanQRCode({
          needResult, 
          scanType, 
          success: function (res) {
            resolve({
              code: 1,
              msg: 'success',
              data: res && res.resultStr
            })
          }
        })
      }).catch((value) => {
        reject(value && value.message || '获取签名失败')
      })  
    })
  }
  /**
   * @description: 获取经纬度信息
   * @param {*} type // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
   * @return {*} {
   * latitude // 纬度，浮点数，范围为90 ~ -90
   * longitude // 经度，浮点数，范围为180 ~ -180
   * }
   */
  getLocation({type ='wgs84'}={}) {
    return new Promise((resolve,reject)=>{
      this.ready(() => {
        wx && wx.getLocation({
          type: type,
          success: function (res) {
            const {latitude, longitude} = res || {}
            resolve({
              code: 1,
              msg: 'success',
              data: {
                lat: latitude,
                lng: longitude,
              }
            })
          }
        })
        setTimeout(() => {
          reject('获取地理信息失败')
        }, 3000)     
      }).catch((value) => {
        reject(value && value.message || '获取签名失败')
      })   
    })
  }
  /**
   * @description: 使用微信内置地图查看位置
   * @param {*} latitude  // 纬度，浮点数，范围为90 ~ -90
   * @param {*} longitude  // 经度，浮点数，范围为180 ~ -180。
   * @param {*} name // 位置名
   * @param {*} address // 地址详情说明
   * @param {*} scale // 地图缩放级别,整形值,范围从1~28。默认为最大
   * @param {*} infoUrl // 在查看位置界面底部显示的超链接,可点击跳转
   * @return {*}
   */
  openLocation({latitude=32.04,longitude=118.73,name='',address='',scale=11, infoUrl=''}={}){
    this.ready(() => {
      wx && wx.openLocation({
        latitude,
        longitude,
        name,
        address,
        scale,
        infoUrl
      })           
    })
  }
  /**
   * @description: 关闭当前网页窗口
   * @param {*}
   * @return {*}
   */
  closeWindow() {
    this.ready(() => {
      wx && wx.closeWindow()      
    })
  }
  /**
   * @description: 批量隐藏功能按钮接口
   * @param {*} itemList // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮
   * @return {*}
   */
  hideMenuItems({itemList} = {}) {
    this.ready(() => {
      wx && wx.hideMenuItems({
        menuList: itemList
      })           
    })
  }
  /**
   * @description: 批量显示功能按钮接口
   * @param {*} itemList // 要显示的菜单项
   * @return {*}
   */
  showMenuItems({itemList} = {}) {
    this.ready(() => {
      wx && wx.showMenuItems({
        menuList: itemList
      })           
    })
  }
  /**
   * @description: 隐藏所有非基础按钮接口
   * @param {*}
   * @return {*}
   */
  hideAllNonBaseMenuItem() {
    this.ready(() => {
      wx && wx.hideAllNonBaseMenuItem()                
    })  
  }
  /**
   * @description: 显示所有功能按钮接口
   * @param {*}
   * @return {*}
   */
  showAllNonBaseMenuItem() {
    this.ready(() => {
      wx && wx.showAllNonBaseMenuItem()                
    })   
  }
  /**
   * @description: 设置分享信息
   * @param {*} options
   * @return {*}
   */
  share(options) {
    this.ready(() => {
      // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
      wx && wx.updateAppMessageShareData(options)
      // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0）
      wx && wx.updateTimelineShareData(options)
      // 获取“分享到朋友圈”按钮点击状态及自定义分享内容接口
      wx && wx.onMenuShareTimeline(options)
      // 获取“分享给朋友”按钮点击状态及自定义分享内容接口
      wx && wx.onMenuShareAppMessage(options)
      // 获取“分享到QQ”按钮点击状态及自定义分享内容接口
      wx && wx.onMenuShareQQ(options)
      // 获取“分享到腾讯微博”按钮点击状态及自定义分享内容接口
      wx && wx.onMenuShareWeibo(options)
      // 获取“分享到QQ空间”按钮点击状态及自定义分享内容接口
      wx && wx.onMenuShareQZone(options)
    })
  }
  openBusinessView({businessType='wxpayScoreDetail', queryString=''}) {
    this.ready(() => {
      wx && wx.invoke('openBusinessView',{
        businessType,
        queryString
      },
      function (res) {
        // 从微信侧小程序返回时会执行这个回调函数
        if (parseInt(res.err_code) === 0) {
          console.log('success')
        } else {
        // 返回失败
          console.log(res && res.errMsg || '获取微信支付分信息失败')
        }
      })
    })
  }
}
export default weChat